import React from 'react';

import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  ExternalLink,
} from '../../components';
import StaticPage from '../../containers/StaticPage/StaticPage';
import TopbarContainer from '../../containers/TopbarContainer/TopbarContainer';
import ClubInfo from './ClubInfo/ClubInfo';
import ClubList from './ClubList/ClubList';

import css from './WineClubsPage.module.css';


const WineClubsPage = () => {

  // prettier-ignore
  return (
    <StaticPage
      title="Wine Clubs"
      schema={{
        '@context': 'http://schema.org',
        '@type': 'WineClubsPage',
        description: 'Wine Clubs',
        name: 'Wine Clubs',
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>

        <LayoutWrapperMain>
         <div className={css.layoutWrapperHeader}>
           <div className={css.layoutWrapperHeaderContent}>
            <h1>Signor Vineyards Wine Club</h1>
            <p>Curate your own experience with one of our tailored wine clubs</p>
           </div>
         </div>
         <div>
           <ClubInfo />
         </div>
         <div className={css.layoutWrapperClubList}>
           <div className={css.ClubInfoClubListWrapper}>
            {[1, 2, 3].map((_, index) => (
              <ClubList />
            ))}
           </div>
         </div>
        </LayoutWrapperMain>

        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </StaticPage>
  );
};

export default WineClubsPage;
